export type TipoPendenciaRelatorio = 'estadual-inscrita' | 'estadual-nao-inscrita' | 'federal';

export const TIPO_PENDENCIA_RELATORIO_OPTIONS: Array<{ label: string; value: TipoPendenciaRelatorio }> = [
  { label: 'Pendência estadual inscrita', value: 'estadual-inscrita' },
  { label: 'Pendência estadual não inscrita', value: 'estadual-nao-inscrita' },
  { label: 'Pendência federal', value: 'federal' }
];

export const TYPE_CND_PENDENCIA: Record<TipoPendenciaRelatorio, string> = {
  'estadual-inscrita': 'PENDENCIA-ESTADUAL',
  'estadual-nao-inscrita': 'CONSULTA-PENDENCIAS-NAO-INSCRITAS',
  federal: 'INTEGRA-CONTADOR'
};

const MESES_LABEL = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

/** Competência inicial disponível nos relatórios (mês 0-based). */
const COMPETENCIA_INICIO = { ano: 2026, mes: 3 }; // Abril/2026

/**
 * Gera opções de competência de Abril/2026 até o mês atual (inclusive).
 * Assim a lista acompanha o calendário sem precisar hardcodear novos meses.
 */
export function gerarOpcoesCompetencia(
  dataFim: Date = new Date()
): Array<{ label: string; value: string }> {
  const opcoes: Array<{ label: string; value: string }> = [];
  let ano = COMPETENCIA_INICIO.ano;
  let mes = COMPETENCIA_INICIO.mes;
  const fimAno = dataFim.getFullYear();
  const fimMes = dataFim.getMonth();

  while (ano < fimAno || (ano === fimAno && mes <= fimMes)) {
    const mesNumero = String(mes + 1).padStart(2, '0');
    opcoes.push({
      label: `${MESES_LABEL[mes]} (${ano})`,
      value: `${mesNumero}-${ano}`
    });

    mes += 1;
    if (mes > 11) {
      mes = 0;
      ano += 1;
    }
  }

  return opcoes;
}

export const COMPETENCIA_RELATORIO_OPTIONS = gerarOpcoesCompetencia();
